import React from 'react';
import TabbedPage from '../../components/common/TabbedPage';
import VatReturn from './VatReturn';
import VatSettings from '../settings/VatSettings';
import TaxReport from './TaxReport';

// Billing › Tax — /reports/vat-return?tab=return|output|input|settings (VAT settings moved here from Configuration).
const TaxTabs = ({ currentUser }) => (
  <TabbedPage tabs={[
    { key: 'return', label: 'VAT Return', element: <VatReturn currentUser={currentUser} /> },
    { key: 'output', label: 'Tax Output', element: <TaxReport direction="output" /> },
    { key: 'input', label: 'Tax Input', element: <TaxReport direction="input" /> },
    { key: 'settings', label: 'VAT Settings', element: <VatSettings currentUser={currentUser} /> },
  ]} />
);

export default TaxTabs;
